import { createSlice, EntityState } from '@reduxjs/toolkit';
import { loadDefaultLayout, loadLayouts } from 'redux/layout-read/layout-read.slice';
import { GadgetModel } from 'types/entity';
import { gadgetsAdaptor } from './gadget-read.adapter';

export const GADGET_READ_STORE_NAME = 'gadgetRead';

export type GadgetReadState = EntityState<GadgetModel> & {
  loaded: boolean
  error?: any
}

export const initialGadgetReadState: GadgetReadState = gadgetsAdaptor.getInitialState({
  loaded: false,
  error: null,
});

export const gadgetReadSlice = createSlice({
  name: GADGET_READ_STORE_NAME,
  initialState: initialGadgetReadState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadLayouts.fulfilled, (state, action) => {
      state.loaded = true;
      gadgetsAdaptor.upsertMany(state, action.payload.gadget || {});
    });
    builder.addCase(loadDefaultLayout.fulfilled, (state, action) => {
      const gadgets = action.payload.gadget;
      state.loaded = true;
      gadgetsAdaptor.upsertMany(state, gadgets || []);
    });
  },
});

export const gadgetReadActions = {
  ...gadgetReadSlice.actions,
};

export default gadgetReadSlice.reducer;
